import React, {useEffect, useState } from "react";

import { Header } from "../../../components/header/Header";
import { ArtistCard } from "../../../components/artist/ArtistCard";



import { useDispatch, useSelector } from "react-redux";
import { getUserListThunk } from "../../../slices/artists/thunk";
import { createSelector } from "@reduxjs/toolkit";
import { getRole } from "../../../utils/GetRole";



export const UserSList = () => {

  const dispatch = useDispatch();

  const selecArtistState = (state) => state.user;
  const contestSelector = createSelector(selecArtistState, (artist) => ({
    isLoading: artist.isLoading,
    users: artist.users,
  }));

  const { users } = useSelector(contestSelector);
  const fileUrl = process.env.REACT_APP_FILE_URL;

  const [role,setRole]=useState(getRole);


  useEffect(() => {
    dispatch(getUserListThunk({ userType:1}));
  }, [dispatch]);


  const cardsData = users?.map((user) => ({
    id: user.id,
    name: user.name,
    userType:'user',
    image: user.image ? `${fileUrl}/${user.image}` : null,
  })) || [];


  return (
    <>

      <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
        <Header name="" />
      </header>

    
      <div className="w-full  mx-auto bg-[#F7F7F7]">
   <div className="w-full">
  <div className="w-full flex items-center justify-between mt-6">
    <span className="font-bold text-black text-[22px] font-grotesk">
      Users
    </span>
  </div>

  <div className="w-full mt-6 mb-5">
    <ArtistCard artists={cardsData} role={role} />
  </div>
</div>

      </div>
    </>
  );
};
